import format from 'date-fns/format'

/**
 * 月份转年
 */
export function monthToYear(value) {
    const month = parseInt(value);
    if(month>=12&&(month%12==0)){
      return (month/12)
    }else if(month>=12){
      return parseInt(month/12)+'.'+(month%12);
    }else{
      return month
    }
}

/**
 * 金额格式化
 */
export function amountFormat(value) {
    const amount = parseFloat(value);
    if (amount > 10000) {
        return parseFloat(value / 10000);
    } else {
        return amount;
    }
}

/**
 * 金额单位格式化
 */
export function unitFormat(value) {
    const amount = parseInt(value);
    if (amount < 10000) {
        return '元';
    } else {
        return '万元';
    }
}

/**
 * 金额单位格式化
 */
export function amountUnitFormat(amount, month) {
    amount = parseFloat(amount);
    month = parseInt(month);
    if (amount < 10000) {
        if( amount === 0){
            amount = '--';
        }
        if (month < 12) {
            return amount + '元/'+ month +'月';
        }
        if (month === 12) {
            return amount + '元/年';
        }
        if (month === 24) {
            return amount + '元/2年';
        }
    } else {
        amount = parseFloat(amount / 10000);
        if (month < 12) {
            return amount + '万元/'+ month +'月';
        }
        if (month === 12) {
            return amount + '万元/年';
        }
        if (month === 24) {
            return amount + '万元/2年';
        }
    }
}
/**
 * 日期格式化
 */
export function dateFormat(date, parttern='yyyy-MM-dd HH:mm:ss') {
    if (date) {
        return format(date,parttern)
    } else {
        return '--';
    }
}
/**
 * 数字格式化
 */
export function numFormat(value) {
    let realVal = parseFloat(value).toFixed(2)
    return realVal;
}

/**
 * 优惠金额保留2位小数
 */
 export function twinPointAmountFormat(a,b) {
    var c, d, e;
    if(undefined==a||null==a||""==a||isNaN(a)){a=0;}
    if(undefined==b||null==b||""==b||isNaN(b)){b=0;}
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    e = Math.pow(10, Math.max(c, d));
    return (floatMul(a, e) - floatMul(b, e)) / e;
}
/**
 * 获取实际支付总金额
 * @param {*} a 
 * @param {*} b 
 * @param {*} c 
 * @returns 
 */
export function getPayMoneyTotal(a,b,c){
    var d;
    d = floatAdd(a,b)
    return floatSub(d,c)
}

/**
 * 获取总优惠金额
 * @returns 
 */
 export function getDisCountMoney(a,b,c,d,e){
    var x,y;
    x = floatSub(a,b)
    y = floatSub(c,d)
    return getPayMoneyTotal(x,y,e)
}

/**
 * 两个数相除
 */
 export function floatDiv(a, b) {
    var c, d, e = 0,
        f = 0;
    try {
        e = a.toString().split(".")[1].length;
    } catch (g) {}
    try {
        f = b.toString().split(".")[1].length;
    } catch (g) {}
    return c = Number(a.toString().replace(".", "")), d = Number(b.toString().replace(".", "")), floatMul(c / d, Math.pow(10, f - e));
}

/**
 * 两个数相减
 */
export function floatSub(a, b) {
    var c, d, e;
    if(undefined==a||null==a||""==a||isNaN(a)){a=0;}
    if(undefined==b||null==b||""==b||isNaN(b)){b=0;}
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    e = Math.pow(10, Math.max(c, d));
    return (floatMul(a, e) - floatMul(b, e)) / e;
}

/**
 * 两个数相乘
 */
 export function floatMul(a, b) {
    var c = 0,
        d = a.toString(),
        e = b.toString();
    try {
        c += d.split(".")[1].length;
    } catch (f) {}
    try {
        c += e.split(".")[1].length;
    } catch (f) {}
    return Number(d.replace(".", "")) * Number(e.replace(".", "")) / Math.pow(10, c);
}

/**
 * 两个数相加
 */
 export function floatAdd(a, b) {
    var c, d, e;
    if(undefined==a||null==a||""==a||isNaN(a)){a=0;}
    if(undefined==b||null==b||""==b||isNaN(b)){b=0;}
    try {
        c = a.toString().split(".")[1].length;
    } catch (f) {
        c = 0;
    }
    try {
        d = b.toString().split(".")[1].length;
    } catch (f) {
        d = 0;
    }
    e = Math.pow(10, Math.max(c, d));
    return  (floatMul(a, e) + floatMul(b, e)) / e;
}



// WEBPACK FOOTER //
// ./src/filters/index.js